import { format } from "date-fns";

interface IProps {
    key?: string;
    data: any;
}

export const BoxMaintenance = (props: IProps) => {
    const { data, key } = props;

    return (
        <div className="box-maintenance" key={key}>
            <div className="img-maintenance">
                <img src={data.img || "../../images/img-maintenance.png"} alt="" />
            </div>
            <div className="title-maintenance">{data.workTypeName || "invalid"}</div>
            <div className="date-maintenance">
                Period Date :
                <span>
                    {`${format(data.startDate, "DD/MM/YYYY")} - ${format(
                        data.endDate,
                        "DD/MM/YYYY"
                    )}` || "invalid"}
                </span>
            </div>
            <div className="visit-maintenance">
                Total Visit :{" "}
                <span className={data.visited === data.totalVisit ? "fullpoint" : "point"}>
                    {data.visited || "0"}/
                </span>
                <span>{data.totalVisit} Times</span>
            </div>
            {data.status ? (
                <div className="status-maintenance">
                    {data.visited === data.totalVisit ? "" : "Available"}
                </div>
            ) : null}
        </div>
    );
};
